export default "__VITE_PUBLIC_ASSET__fb7421ef__"